import { render, staticRenderFns } from "./ConsultationsDeSuiviCreate.vue?vue&type=template&id=dea1b356&"
import script from "./ConsultationsDeSuiviCreate.vue?vue&type=script&lang=js&"
export * from "./ConsultationsDeSuiviCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports